import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { canAccessModule } from "@/lib/rbac";

/**
 * Route guard — redirige al home del portal si el usuario no puede acceder al módulo.
 * Usar como wrapper: <RequireModule module="aula"><AulaHome /></RequireModule>
 */
export default function RequireModule({ module, children }) {
  const { user } = useAuth();
  if (!user) return null; // AppShell ya redirige a /login
  if (!canAccessModule(user, module)) {
    return <Navigate to="/app" replace />;
  }
  return children;
}
